import React, {Fragment, useEffect} from 'react';
import Error from '../../components/404'
import NewNavbar from '../../new-components/NewNavbar'
import NewPageHeader from "../../new-components/NewPageHeader";
import NewOverrides from '../../new-components/NewOverrides'
import NewDesignSystem from '../../new-components/NewDesignSystem'
import NewFooter from '../../new-components/NewFooter'
import NewMadeWith from '../../new-components/NewMadeWith'
import NewScrollTop from '../../new-components/NewScrollTop'

const ErrorPage =() => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return(
        <Fragment>
            <NewNavbar/>
            <NewOverrides/>
            <NewDesignSystem/>

      <NewPageHeader />
            <Error/>
            <NewFooter/>
            <NewMadeWith/>
            <NewScrollTop/>
        </Fragment>
    )
};
export default ErrorPage;

